import update from 'immutability-helper';
import {
  INIT_PROFILE,
  GET_PORFILE,
  SET_SWITCH_ACCOUNT,
  GET_PHOTOS,
  GET_PUBLIC_TRIPS,
  GET_PUBLIC_COLLECTIONS_LIST,
  GET_PUBLIC_PUBLISHED,
  GET_PUBLIC_LIKED,
  SET_PROFILE_TAB,
  SET_PROFILE_LIKE,
  GET_ACCOUNT_LIST,
  GET_PROFILE_MEMBERS,
  GET_PROFILE_PRODUCT_LIST,
  GET_PROFILE_FANS,
  GET_PROFILE_FOLLOWINGS,
  SET_CURRENT_PROFILE_FOLLOWINGS,
  GET_RECOMMEND_FOLLOWINGS,
  UPLOAD_AVATAR,
  UPLOAD_PROFILE_COVER,
} from '../actionTypes/profile';
import { SET_FOLLOWING } from '../actionTypes/following';

const initState = {
  currentTabName: 'Overview',
  publicLiked: {
    dataNext: false,
    data: [],
    isLoading: true,
  },
  publicTrips: {
    dataNext: false,
    data: [],
    isLoading: true,
    totalCount: 0, // trips 無限滾動 API 和 Likes、Journals 不同 需要自己計算還需要向後端索取多少數量
  },
  publicPublished: {
    dataNext: false,
    data: [],
    isLoading: true,
  },
  publicCollections: {
    dataNext: false,
    data: [],
    isLoading: true,
  },
  profile: {
    data: {},
    isLoading: true,
    switchLoadingStatus: 'init',
  },
  photos: {
    isLoading: true,
    data: [],
    dataNext: false,
  },
  products: {
    isLoading: true,
    data: [],
    dataNext: false,
  },
  ownsAccount: [],
  fans: {
    isLoading: true,
    data: [],
    dataNext: false,
  },
  followings: {
    isLoading: true,
    data: [],
    dataNext: false,
  },
  groupMembers: {
    isLoading: true,
    data: [],
    dataNext: false,
  },
  recommendFollowings: {
    isLoading: true,
    data: [],
    dataNext: false,
  },
};

const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    case INIT_PROFILE:
      return { ...initState };
    case SET_PROFILE_TAB:
      return {
        ...state,
        currentTabName: action.currentTabName,
      };
    case GET_PORFILE.LOADING:
      return {
        ...state,
        profile: {
          data: {},
          isLoading: true,
        },
      };
    case GET_PORFILE.SUCCESS:
      return {
        ...state,
        profile: {
          data: { ...action.data },
          isLoading: false,
        },
      };
    case GET_PORFILE.FAIL:
      return {
        ...state,
        profile: {
          data: {},
          isLoading: false,
        },
      };
    case SET_SWITCH_ACCOUNT.LOADING:
      return {
        ...state,
        profile: {
          ...state.profile,
        },
      };
    case SET_SWITCH_ACCOUNT.SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          switchLoadingStatus: 'success',
        },
      };
    case SET_SWITCH_ACCOUNT.FAIL:
      return {
        ...state,
        profile: {
          ...state.profile,
          switchLoadingStatus: 'fail',
        },
      };
    case UPLOAD_AVATAR.SUCCESS: {
      const avatar = action.avatar;
      if (avatar) {
        const newData = { ...state.profile.data, imageUrl: avatar, avatar };
        return {
          ...state,
          profile: {
            ...state.profile,
            data: newData,
          },
        };
      }

      return state;
    }

    case UPLOAD_PROFILE_COVER.SUCCESS: {
      const { cover } = action;
      if (cover) {
        const newData = { ...state.profile.data, cover };
        return {
          ...state,
          profile: {
            ...state.profile,
            data: newData,
          },
        };
      }

      return state;
    }
    case GET_PHOTOS.LOADING:
      return {
        ...state,
        photos: {
          ...state.photos,
          isLoading: true,
        },
      };
    case GET_PHOTOS.SUCCESS:
      return {
        ...state,
        photos: {
          data: action.data,
          isLoading: false,
          dataNext: action.dataNext,
        },
      };
    case GET_PHOTOS.NEXT:
      return {
        ...state,
        photos: {
          data: [...state.photos.data, ...action.data],
          isLoading: false,
          dataNext: action.dataNext,
        },
      };
    case GET_PHOTOS.FAIL:
      return {
        ...state,
        photos: {
          data: [],
          isLoading: false,
          dataNext: false,
        },
      };
    case GET_PROFILE_PRODUCT_LIST.LOADING:
      return {
        ...state,
        products: {
          ...state.products,
          isLoading: true,
        },
      };
    case GET_PROFILE_PRODUCT_LIST.SUCCESS:
      return {
        ...state,
        products: {
          data: action.data,
          isLoading: false,
          dataNext: action.dataNext,
        },
      };
    case GET_PROFILE_PRODUCT_LIST.FAIL:
      return {
        ...state,
        products: {
          data: [],
          isLoading: false,
          dataNext: false,
        },
      };
    case GET_PROFILE_PRODUCT_LIST.NEXT:
      return {
        ...state,
        products: {
          data: [...state.products.data, ...action.data],
          isLoading: false,
          dataNext: action.dataNext,
        },
      };

    case GET_PUBLIC_TRIPS.LOADING:
      return {
        ...state,
        publicTrips: {
          ...state.publicTrips,
          isLoading: true,
        },
      };
    case GET_PUBLIC_TRIPS.SUCCESS:
      return {
        ...state,
        publicTrips: {
          data: action.data,
          totalCount: action.totalCount,
          dataNext: action.dataNext,
          isLoading: false,
        },
      };
    case GET_PUBLIC_TRIPS.FAIL:
      return {
        ...state,
        publicTrips: {
          data: [],
          totalCount: 0,
          dataNext: false,
          isLoading: false,
        },
      };
    case GET_PUBLIC_COLLECTIONS_LIST.LOADING:
      return {
        ...state,
        publicCollections: {
          ...state.publicCollections,
          isLoading: true,
        },
      };
    case GET_PUBLIC_COLLECTIONS_LIST.SUCCESS:
      return {
        ...state,
        publicCollections: {
          dataNext: action.dataNext,
          data: action.data,
          isLoading: false,
        },
      };
    case GET_PUBLIC_COLLECTIONS_LIST.FAIL:
      return {
        ...state,
        publicCollections: {
          dataNext: false,
          data: [],
          isLoading: false,
        },
      };
    case GET_PUBLIC_PUBLISHED.LOADING:
      return {
        ...state,
        publicPublished: {
          ...state.publicPublished,
          isLoading: true,
        },
      };
    case GET_PUBLIC_PUBLISHED.SUCCESS:
      return {
        ...state,
        publicPublished: {
          dataNext: action.dataNext,
          data: action.data,
          isLoading: false,
        },
      };
    case GET_PUBLIC_PUBLISHED.FAIL:
      return {
        ...state,
        publicPublished: {
          dataNext: false,
          data: [],
          isLoading: false,
        },
      };
    case GET_PUBLIC_LIKED.LOADING:
      return {
        ...state,
        publicLiked: {
          ...state.publicLiked,
          isLoading: true,
        },
      };
    case GET_PUBLIC_LIKED.SUCCESS:
      return {
        ...state,
        publicLiked: {
          dataNext: action.dataNext,
          data: action.data,
          isLoading: false,
        },
      };
    case GET_PUBLIC_LIKED.FAIL:
      return {
        ...state,
        publicLiked: {
          dataNext: false,
          data: [],
          isLoading: false,
        },
      };
    case GET_ACCOUNT_LIST.LOADING:
      return {
        ...state,
        ownsAccount: [],
      };
    case GET_ACCOUNT_LIST.SUCCESS:
      return {
        ...state,
        ownsAccount: action.ownsAccount,
      };
    case GET_ACCOUNT_LIST.FAIL:
      return {
        ...state,
        ownsAccount: [],
      };
    case GET_PUBLIC_PUBLISHED.NEXT:
      return {
        ...state,
        publicPublished: {
          ...state.publicPublished,
          dataNext: action.dataNext,
          data: state.publicPublished.data.concat(action.concatData),
        },
      };
    case GET_PUBLIC_LIKED.NEXT:
      return {
        ...state,
        publicLiked: {
          ...state.publicLiked,
          dataNext: action.dataNext,
          data: state.publicLiked.data.concat(action.concatData),
        },
      };
    case GET_PUBLIC_TRIPS.NEXT:
      return {
        ...state,
        publicTrips: {
          ...state.publicTrips,
          dataNext:
            action.totalCount >
            state.publicTrips.data.length + action.concatData.length,
          data: state.publicTrips.data.concat(action.concatData),
          isLoading: false,
          totalCount: action.totalCount,
        },
      };
    case GET_PUBLIC_COLLECTIONS_LIST.NEXT:
      return {
        ...state,
        publicCollections: {
          ...state.publicCollections,
          dataNext: action.dataNext,
          data: state.publicCollections.data.concat(action.data),
        },
      };
    case SET_PROFILE_LIKE.COLLECTIONS:
      return setOverviewCollectionsLike(state, action);
    case SET_PROFILE_LIKE.TRIPS:
      return setOverviewTripsLike(state, action);
    case SET_PROFILE_LIKE.JOURNALS:
      return setOverviewJournalsLike(state, action);
    case SET_PROFILE_LIKE.PRODUCTS:
      return setOverviewProductsLike(state, action);
    case GET_PROFILE_MEMBERS.LOADING:
      return {
        ...state,
        groupMembers: {
          data: [],
          dataNext: false,
          isLoading: true,
        },
      };
    case GET_PROFILE_MEMBERS.SUCCESS:
      return {
        ...state,
        groupMembers: {
          data: action.data,
          dataNext: action.dataNext,
          isLoading: false,
        },
      };
    case GET_PROFILE_MEMBERS.FAIL:
      return {
        ...state,
        groupMembers: {
          data: [],
          dataNext: false,
          isLoading: false,
        },
      };
    case GET_PROFILE_MEMBERS.NEXT_SUCCESS:
      return {
        ...state,
        groupMembers: {
          ...state.groupMembers,
          data: state.groupMembers.data.concat(action.concatData),
          dataNext: action.dataNext,
        },
      };
    case GET_PROFILE_FOLLOWINGS.LOADING:
      return {
        ...state,
        followings: {
          data: [],
          dataNext: false,
          isLoading: true,
        },
      };
    case GET_PROFILE_FOLLOWINGS.SUCCESS:
      return {
        ...state,
        followings: {
          dataNext: action.payload.dataNext,
          data: action.payload.data,
          isLoading: false,
        },
      };
    case GET_PROFILE_FOLLOWINGS.FAIL:
      return {
        ...state,
        followings: {
          data: [],
          dataNext: false,
          isLoading: false,
        },
      };
    case GET_PROFILE_FOLLOWINGS.NEXT_SUCCESS:
      return {
        ...state,
        followings: {
          data: [...state.followings.data, ...action.payload.data],
          isLoading: false,
          dataNext: action.payload.dataNext,
        },
      };

    case GET_PROFILE_FANS.LOADING:
      return {
        ...state,
        fans: {
          data: [],
          dataNext: false,
          isLoading: true,
        },
      };
    case GET_PROFILE_FANS.SUCCESS:
      return {
        ...state,
        fans: {
          dataNext: action.payload.dataNext,
          data: action.payload.data,
          isLoading: false,
        },
      };
    case GET_PROFILE_FANS.FAIL:
      return {
        ...state,
        fans: {
          data: [],
          dataNext: false,
          isLoading: false,
        },
      };
    case GET_PROFILE_FANS.NEXT_SUCCESS:
      return {
        ...state,
        fans: {
          data: [...state.fans.data, ...action.payload.data],
          isLoading: false,
          dataNext: action.payload.dataNext,
        },
      };
    case SET_CURRENT_PROFILE_FOLLOWINGS.SUCCESS:
      return setCurrentProfileFollowing(state, action);

    case SET_FOLLOWING.SUCCESS:
      return setCurrentProfileFollowing(state, action);
    case GET_RECOMMEND_FOLLOWINGS.LOADING:
      return {
        ...state,
        recommendFollowings: {
          data: [],
          dataNext: false,
          isLoading: true,
        },
      };
    case GET_RECOMMEND_FOLLOWINGS.SUCCESS:
      return {
        ...state,
        recommendFollowings: {
          dataNext: action.payload.dataNext,
          data: action.payload.data,
          isLoading: false,
        },
      };
    case GET_RECOMMEND_FOLLOWINGS.FAIL:
      return {
        ...state,
        recommendFollowings: {
          data: [],
          dataNext: false,
          isLoading: false,
        },
      };
    case GET_RECOMMEND_FOLLOWINGS.NEXT_SUCCESS:
      return {
        ...state,
        recommendFollowings: {
          dataNext: action.payload.dataNext,
          data: [...state.recommendFollowings.data, ...action.payload.data],
          isLoading: false,
        },
      };
    default:
      return state;
  }
};

const setOverviewCollectionsLike = (state, payload) => {
  const { likeCount, isLike, index } = payload;
  const newState = update(state, {
    publicCollections: {
      data: {
        [index]: {
          is_like: { $set: isLike },
          like_counts: { $set: likeCount },
        },
      },
    },
  });
  return newState;
};
const setOverviewTripsLike = (state, payload) => {
  const { likeCount, isLike, index } = payload;
  const newState = update(state, {
    publicTrips: {
      data: {
        [index]: {
          isLike: { $set: isLike },
          likeCount: { $set: likeCount },
        },
      },
    },
  });
  return newState;
};

const setOverviewJournalsLike = (state, payload) => {
  const { likeCount, isLike, index } = payload;
  const newState = update(state, {
    publicPublished: {
      data: {
        [index]: {
          is_like: { $set: isLike },
          like_counts: { $set: likeCount },
        },
      },
    },
  });
  return newState;
};
const setOverviewProductsLike = (state, payload) => {
  console.log(
    '🚀 ~ file: profile.js ~ line 447 ~ setOverviewProductsLike ~ payload',
    payload,
  );
  const { likeCount, isLike, index } = payload;
  const newState = update(state, {
    products: {
      data: {
        [index]: {
          is_like: { $set: isLike },
          like_counts: { $set: likeCount },
        },
      },
    },
  });
  return newState;
};

/**
 * 取消追蹤不用移除已存在 followings 和 fans 的 member，但追蹤某人要檢查 followings 和 fans 是否存在該 user，沒有就加進去
 */
const setFollowing = (state, action) => {
  const { data } = action.payload;
  const followingList = state.followings.data;
  const fanList = state.fans.data;

  const isInFollowingList = followingList.find(
    item => item.userid === data.userid,
  );
  const isInFanList = fanList.find(item => item.userid === data.userid);
  return {
    ...state,
    followings: {
      ...state.followings,
      data: isInFollowingList ? followingList : [...followingList, data],
    },
    fans: {
      ...state.fans,
      data: isInFanList ? fanList : [...fanList, data],
    },
  };
};

const setCurrentProfileFollowing = (state, action) => {
  const { data, currentUserID, currentFollowing, accountData } = action.payload;
  const followingList = state.followings.data;
  const fanList = state.fans.data;

  if (data.userid === currentUserID) {
    let fansData;
    const isInFanList = fanList.find(
      item => item.userid === accountData.userid,
    );

    if (!currentFollowing && isInFanList) {
      fansData = fanList.filter(item => item.userid !== accountData.userid);
    } else if (
      (currentFollowing && isInFanList) ||
      (!currentFollowing && !isInFanList)
    ) {
      fansData = fanList;
    } else if (accountData) {
      fansData = [...fanList, accountData];
    } else {
      fansData = [...fanList];
    }

    return {
      ...state,
      followings: {
        ...state.followings,
        data: followingList,
      },
      fans: {
        ...state.fans,
        data: fansData,
      },
    };
  }

  return state;
};
